<style scoped>

</style>

<template>

  <!-- <v-card
    style="
        width:22rem;heigth:20;position:relative;
        border-style: solid;
        border-width: 0em 0em 0em 0.3em;
        border-color: #FFC107; 
    "
  >
    <v-card-title>
        <v-img
        class="elevation-2"
        :src="img"
        ></v-img>
      <span class="title font-weight-light">{{name}}</span>
    </v-card-title>

    <v-card-text class="headline font-weight-bold;">
        <div id="" style="width:23rem;margin:-3rem;">
            <canvas ref="chartgauge"></canvas>
        </div>     
    </v-card-text>

    <v-card-actions>
    </v-card-actions>
  </v-card> -->
  <div
    style="
        border-style: solid;
        border-width: 0em 0em 0em 0.3em;
        border-color: #FFC107; 
    "  
  >
  <v-card
    color="grey lighten-4"
    style="
        
        width:100%;
        border-style: solid;
        border-width: 0em 0em 0em 0.3em;
        border-color: #FFC107; 
    "
  >
    <v-card-title>
      <v-layout row wrap align-center >
          <div v-if="isAMessage==true" style="margin-right:0.5rem"> 
            <v-icon v-if="severity==0" color="green">check_circle</v-icon>
            <v-icon v-else-if="severity==1" color="amber">warning</v-icon>
            <v-icon v-else-if="severity==2" color="red">error</v-icon>
            <v-icon v-else color="primary">info</v-icon>
          </div>
          <img 
              v-else-if="img"
              style="width:2.2rem;float:right;margin-right:0.5rem"
              :src="img"
              onerror="this.style.display='none'"
          />
          <v-icon color="#39a9dc" v-else>{{icon}}</v-icon>
          <div style="text-color:#757575;overflow: hidden;text-overflow: ellipsis;white-space:nowrap;float:right" class="body-2 text-uppercase">
            {{name}}
          </div>

      <v-flex xs12>
        <v-layout
          column
          align-start
          style="margin-top:0.5rem; margin-left:1.5rem"
        >
          <!-- <div style="text-color:#757575;overflow: hidden;text-overflow: ellipsis;white-space:nowrap;" class="body-2 text-uppercase">
            {{name}}
          </div> -->
          <div v-if="isAMessage==true" class="subheading">  
            {{value}}
          </div>
          <div v-else-if="!(value instanceof Object)"> 
            <span
              class="title"
              v-text="value || '—'"
            ></span>
            <strong v-if="unit">unit</strong>
          </div>
          <div v-else-if="(value instanceof Object)"> 
              <div v-for="key in Object.keys(value)" :key="key">
                  <span
                      class="title"
                      style="margin-right:0.3rem"
                      v-text="key || '—'"
                  ></span>
                  <span
                      class="title font-weight-black"
                      v-text="value[key] || '—'"
                  ></span>
              </div>
            <strong v-if="unit">unit</strong>
          </div>
        </v-layout>
      </v-flex>
      </v-layout>
    </v-card-title>
  </v-card>
  </div>
</template>

<script>
// const Chart = require('../../node_modules/chartjs-gauge/dist/chartjs-gauge.js');

export default {
    name:"Gauge",
    props:[
        'name',
        'img',
        'icon',
        'ranges',
        'value',
        'unit',
        'severity',
        'isAMessage'
    ],
    
    data(){
        return{
            config:{
                type: 'gauge',
                data: {
                    //labels: ['Success', 'Warning', 'Warning', 'Error'],
                    datasets: []
                },
                options: {
                    responsive: true,
                    title: {
                    display: true,
                    },
                    layout: {
                    padding: {
                        bottom: 30
                    }
                    },
                    needle: {
                    // Needle circle radius as the percentage of the chart area width
                    radiusPercentage: 2,
                    // Needle width as the percentage of the chart area width
                    widthPercentage: 3.2,
                    // Needle length as the percentage of the interval between inner radius (0%) and outer radius (100%) of the arc
                    lengthPercentage: 80,
                    // The color of the needle
                    color: 'rgba(0, 0, 0, 1)'
                    },
                    valueLabel: {
                    formatter: Math.round
                    }
                }
            }
        }
    },

    // created(){
    //     if(this.value instanceof Object){
    //         for(let index in this.value){
    //             this.config.data.datasets.push({
    //                 data: this.ranges ,
    //                 value: this.value[index],
    //                 backgroundColor: ['green', 'yellow', 'orange', 'red'],
    //                 borderWidth: 2,
    //                 name: this.name+" "+index
    //             })
    //         }
    //     }else{
    //         this.config.data.datasets[0]={
    //             data: this.ranges ,
    //             value: this.value,
    //             backgroundColor: ['green', 'yellow', 'orange', 'red'],
    //             borderWidth: 2,
    //             name: this.name
    //         }
    //     }

    // },

    // mounted(){
    //     this.chartDomElement = this.$refs["chartgauge"];
    //     this.chart = new Chart(this.chartDomElement, this.config);
    // },

    // watch:{

    //     value:{
    //         deep: true,
    //         handler(){
    //             this.config.data.datasets.splice(0)
    //             if(this.value instanceof Object){
    //                 for(let index in this.value){
    //                     let stored = this.config.data.datasets.find(d=>d.name==this.name+" "+index)
    //                     if(stored)
    //                         stored.value= this.value
    //                     else
    //                         this.config.data.datasets.push({
    //                             data: this.ranges ,
    //                             value: this.value[index],
    //                             backgroundColor: ['green', 'yellow', 'orange', 'red'],
    //                             borderWidth: 2,
    //                             name:this.name+" "+index
    //                         })
    //                 }
    //             }else{
    //                 if(this.config.data.datasets[0])
    //                     this.config.data.datasets[0].value= this.value
    //                 else
    //                     this.config.data.datasets[0]={
    //                         data: this.ranges ,
    //                         value: this.value,
    //                         backgroundColor: ['green', 'yellow', 'orange', 'red'],
    //                         borderWidth: 2,
    //                         name: this.name
    //                     }
    //             }
    //             this.chart.update()
    //         }
    //     }
    // },
    
    methods:{

    }
}
</script>

